function ToolTypeModal({
  show,
  onClose,
  onCreateFromImage,
  onCreateCustomTool,
}) {
  if (!show) return null;

  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ backdropFilter: "blur(5px)" }}
      ></div>
      <div
        className="modal fade show d-block"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-body-highlight p-6">
            <div className="modal-header justify-content-between border-0 p-0 mb-2">
              <h3 className="mb-0">Add Tool</h3>
            </div>
            <div className="modal-body px-0">
              <div className="row g-3">
                <div className="col-12">
                  <button
                    className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center p-3"
                    onClick={onCreateFromImage}
                  >
                    <div className="text-center">
                      <div className="fw-semibold">Upload from Image</div>
                      <small className="text-muted">
                        Generate tool configuration from an image
                      </small>
                    </div>
                  </button>
                </div>
                <div className="col-12">
                  <button
                    className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center p-3"
                    onClick={onCreateCustomTool}
                  >
                    <div className="text-center">
                      <div className="fw-semibold">Create Custom Tool</div>
                      <small className="text-muted">
                        Manually configure a new tool
                      </small>
                    </div>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0 px-0 pb-0">
              <button
                id="modalCloseButton"
                className="btn btn-link text-danger px-3 my-0"
                data-bs-dismiss="modal"
                type="button"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ToolTypeModal;
